import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { ShareResourceEnum } from '../enum/share-resource-enum';
import { ShareResourceInterface, ShareResourceNewFlowInterface } from '../types/share-interface';
import { getResourceApiSlug } from '../utils/get-resource-api-slug';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
type SwrFetcherConfig = {
  signal?: AbortSignal;
};
export const useShareResource = t0 => {
  const $ = _c(20);
  const {
    hash,
    type
  } = t0;
  let t1;
  if ($[0] !== type) {
    t1 = getResourceApiSlug(type);
    $[0] = type;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const resourceApiSlug = t1;
  const isPostFetcher = type === ShareResourceEnum.Website;
  const isNewFlow = type === ShareResourceEnum.Workflow;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.get,
      badRequestHandler(error) {
        throw error;
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    fetcher: getOldFlowFetcher
  } = useFetch(t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      method: RequestMethodsEnum.post,
      badRequestHandler(error_0) {
        throw error_0;
      }
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    fetcher: postOldFlowFetcher
  } = useFetch(t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      method: RequestMethodsEnum.post,
      badRequestHandler(error_1) {
        throw error_1;
      }
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const {
    fetcher: postNewFlowFetcher
  } = useFetch(t4);
  let t5;
  if ($[5] !== getOldFlowFetcher || $[6] !== isPostFetcher || $[7] !== postOldFlowFetcher) {
    t5 = (url, config) => {
      if (isPostFetcher) {
        return postOldFlowFetcher(url, undefined, config);
      }
      return getOldFlowFetcher(url, config);
    };
    $[5] = getOldFlowFetcher;
    $[6] = isPostFetcher;
    $[7] = postOldFlowFetcher;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const oldFetcher = t5;
  let t6;
  if ($[9] !== postNewFlowFetcher) {
    t6 = (url_0, config_0) => postNewFlowFetcher(url_0, undefined, config_0);
    $[9] = postNewFlowFetcher;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const newFetcher = t6;
  let t7;
  if ($[11] !== hash || $[12] !== resourceApiSlug || $[13] !== type) {
    t7 = () => {
      if (!hash || !type) {
        return;
      }
      switch (resourceApiSlug) {
        case ShareResourceEnum.Funnel:
          {
            return `/api/funnel/share-background/${hash}`;
          }
        case ShareResourceEnum.Blog:
          {
            return `/api/blog/share-background/${hash}`;
          }
        default:
          {
            return `/api/${resourceApiSlug}/share/${hash}`;
          }
      }
    };
    $[11] = hash;
    $[12] = resourceApiSlug;
    $[13] = type;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const {
    data: oldFlowData,
    error: oldFlowError
  } = useControlledSwr(t7, oldFetcher, undefined, !isNewFlow);
  let t8;
  if ($[15] !== hash) {
    t8 = () => {
      if (!hash) {
        return;
      }
      return `/api/dashboard/sharing/share/${hash}`;
    };
    $[15] = hash;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const {
    data: newFlowData,
    error: newFlowError
  } = useControlledSwr(t8, newFetcher, undefined, isNewFlow);
  const t9 = isNewFlow ? newFlowData : oldFlowData;
  const t10 = isNewFlow ? newFlowError : oldFlowError;
  let t11;
  if ($[17] !== t10 || $[18] !== t9) {
    t11 = {
      data: t9,
      error: t10
    };
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
};